import { lazy } from "react";

export const ServiceAsync = lazy(() => import("./Service"));
